// parses 'code' out of e.g. "museapp://join-room?code=p4ykNUcc".
export function parseJoinRoomLink(link: string, paramCode?: string) {
    try {
        const url = new URL(link)
        const code = paramCode ?? url.searchParams?.get('code')
        if (code) {
            const metadata = extractJoinLinkMetadata(url.searchParams)
            const clientType = extractClientType(url.searchParams)
            return { code, metadata, clientType }
        } else {
            return {
                error: {
                    code: 'no_code',
                    message: `The provided url "${link}" does not have "code".`,
                },
            }
        }
    } catch (e) {
        return {
            error: {
                code: 'not_url',
                message: `The provided url "${link}" is not a valid URL.`,
            },
        }
    }
}

function extractJoinLinkMetadata(params: URLSearchParams): { [key: string]: string } {
    let metadata: { [key: string]: string } = {}
    params.forEach((v, k) => {
        if (k.startsWith('m_')) {
            metadata[k.substring(2)] = v
        }
    })
    return metadata
}

function extractClientType(params: URLSearchParams): string {
    let clientType: string = ''
    params.forEach((v, k) => {
        if (k.startsWith('clientType')) {
            clientType = v
        }
    })
    return clientType
}
